import React from 'react'
import { Helmet } from 'react-helmet-async'
import QuotePaymentView from 'src/sections/main-sections/quoteAction/quote-payment-view'

const QuotePaymentPage = () => {
    return (
        <>
            <Helmet>
                <title>Dashboard : Quote Payment Page</title>
            </Helmet>
            <QuotePaymentView/>
        </>
    )
}

export default QuotePaymentPage